import * as React from 'react';
import { Card, CardContent } from 'components/ui/card';

import { ListHeader, ListItems } from './components';

type Props = React.ComponentProps<typeof Card>

export const InvoiceItemsList = ({ ...props }: Props) => {
  return (
    <Card {...props}>
      <CardContent className={'text-gray-600 pt-6'}>
        <ListHeader className={'mb-6'} />
        <ListItems />
      </CardContent>
    </Card>
  );
};